import { ToastS } from '../../../Service/ToastS';
import { DocumentS } from '../../../Templates/Documents/DocumentS';
import { EntityReferenceDTO, WorkflowDTO, WorkflowOperation, WorkflowStepDTO } from '../../../Types/LogT';
import { openAcceptOfferModal } from '../Documents/DocumentModals';

const getCurrentWorkflowStep = (workflow: WorkflowDTO): WorkflowStepDTO | undefined =>
  workflow.steps[workflow.currentStep];

const findCreatedEntityId = (workflow: WorkflowDTO, entityReference: EntityReferenceDTO): number | null => {
  const creatingStep = workflow.steps
    .slice(0, workflow.currentStep)
    .reverse()
    .find(
      (step) =>
        step.entityReference?.id === entityReference.id &&
        step.executionReport?.executionStatus === 'COMPLETED' &&
        step.executionReport?.entityId,
    );

  if (!creatingStep?.executionReport?.entityId) {
    return null;
  }

  const entityId = Number(creatingStep.executionReport.entityId);
  return Number.isNaN(entityId) ? null : entityId;
};

export const shouldHandleOfferConfirmationManually = (workflow: WorkflowDTO): boolean => {
  const currentWorkflowStep = getCurrentWorkflowStep(workflow);

  return (
    currentWorkflowStep?.procedureType === 'WAIT_UNTIL' &&
    currentWorkflowStep.executionConfig.typeOfInterest === 'OFFER_CONFIRMED'
  );
};

export const handleWorkflowForceContinue = async (
  workflow: WorkflowDTO,
  runOperation: (operation: WorkflowOperation) => void,
) => {
  const currentWorkflowStep = getCurrentWorkflowStep(workflow);
  const waitEntity = currentWorkflowStep?.executionConfig?.entityOfInterest;

  if (!shouldHandleOfferConfirmationManually(workflow) || !waitEntity) {
    runOperation('FORCE_CONTINUE');
    return;
  }

  const offerId = findCreatedEntityId(workflow, waitEntity);
  if (!offerId) {
    ToastS.warn('workflow-offer-missing', 'Das zugehoerige Angebot konnte nicht ermittelt werden.');
    return;
  }

  const offer = await DocumentS.fetchById(offerId);
  if (!offer) {
    return;
  }

  if (offer.positions.some((position) => position.optional)) {
    openAcceptOfferModal({ bookitupDocument: offer, onAccept: () => runOperation('FORCE_CONTINUE') });
    return;
  }

  runOperation('FORCE_CONTINUE');
};
